import { useLazyQuery } from '@apollo/react-hooks';
import { yupResolver } from '@hookform/resolvers';
import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import IconText from '@ifca-root/react-component/src/components/Typography/IconText';
import ExcelIcon from '../../../../assets/icons/excel.svg'
import ShareIcon from '@material-ui/icons/Share';
import {ExcelInput} from '@ifca-root/react-component/src/components/Input/ExcelInput';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { useExcelUploadVersion2 } from '@ifca-root/react-component/src/utils/hooks/excelUploadVersion2';
import {
	Button,
	IconButton,
	List,
	ListItem,
	ListItemSecondaryAction,
	ListItemText,
	Menu,
	MenuItem,
	TextField,
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { GeneralDeleteDialog } from 'components/Dialog/GeneralDeleteDialog';
import { GET_CURRENCY } from 'containers/AccountModule/AccountQuery';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import {
	GetDigitalMenuDocument,
	useCreateDigitalMenuMutation,
	useDeleteDigitalMenuMutation,
	useDuplicateDigitalMenuMutation,
	useGetDigitalMenuQuery,
	useGetOutletQuery,
	useIsDigitalMenuInUseLazyQuery,
} from 'generated/graphql';
import { useMenuOption } from 'helpers/hooks/useMenuOption';
import { SystemMsgs } from 'helpers/SystemMsg';
import { CommonYupValidation } from 'helpers/yup';
import { AccountClient } from 'ProductsClient';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import * as yup from 'yup';

interface DigitalMenuProps {
	name: string;
	description: string;
}

export const DigitalMenuList = () => {
	useEffect(() => {
		console.log('DigitalMenuList');
	}, []);
	const history = useHistory();
	const { pathname } = useLocation();
	const { anchorEl, menu, handleClick, handleClose } = useMenuOption();
	const [openDialog, setOpenDialog] = React.useState(false);
	const [openExcelDialog, setOpenExcelDialog] = React.useState(false);
	const [double, setDouble] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	

	const yupSchema = yup.object().shape({
		name: CommonYupValidation.requireField(SystemMsgs.name()),
		description: CommonYupValidation.requireField(SystemMsgs.description()),
	});

	// const [data, setData] = useState(null);
	const { [`outletID`]: outletID } = useParams<Record<string, any>>();
	const { register, control, handleSubmit, errors } = useForm<DigitalMenuProps>(
		{
			defaultValues: {},
			resolver: yupResolver(yupSchema),
		},
	);

	// const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
	// 	SnackBarContext as any,
	// );
	// const {
	// 	called:ouletCalled,
	// 	loading:outletLoading,
	// 	error:outletError,
	// 	data:{getOutlet} ={getOutlet:[]},
	// } = useGetOutletQuery({
	// 	fetchPolicy: 'network-only',
	// 	variables: {ID:outletID},
	// })


	
	// const outletArray: any[] = getOutlet;
	const {
		openFileUpload,
		setOpenFileUpload,
		fileTitle,
		setFileTitle,
		openSnackBar,
		setOpenSnackBar,
		snackBarMessage,
		currentData,
		setCurrentData,
		onDownloadTemplate,
		onSelectFile,
		duplicateItems,
		errorDialog: duplicateErrorDia,
		setErrorDialog,
		resetFileUpload,
		setSnackBarMessage,
	  } = useExcelUploadVersion2();
	const [
		duplicateDigitalMenu,
		{ loading: duplicateDigitalMenuLoading },
	] = useDuplicateDigitalMenuMutation({
		onCompleted: ({ duplicateDigitalMenu }) => {
			setOpenSnackBar(true);
			// setSnackBarMsg('Duplicate successful');
			setSnackBarMessage('Duplicate successful')
			// setSuccess({
			// 	msg: duplicateDigitalMenu ? 'Duplicate successful' : 'Duplicate failed',
			// 	bool: true,
			// });
		},
	});

	const [
		deleteDigitalMenu,
		{ loading: deleteDigitalMenuLoading },
	] = useDeleteDigitalMenuMutation({
		onError: error => {
			if (error.message.includes('FK_')) {
				setOpenSnackBar(true);
				setSnackBarMessage(SystemMsgs.deleteRecordInUse());
				// setSnackBarMsg(SystemMsgs.deleteRecordInUse());
			}
		},
		onCompleted: () => {
			setOpenSnackBar(true);
			setSnackBarMessage(SystemMsgs.deleteRecord());
			// setSnackBarMsg(SystemMsgs.deleteRecord());
		},
	});

	const {
		data: { getDigitalMenu } = { getDigitalMenu: [] },
		loading: digitalMenuLoading,
	} = useGetDigitalMenuQuery({
		fetchPolicy: 'network-only',
		variables: {
			outletID: outletID,
		},
	});

	const [
		newDigitalMenu,
		{ error: digitalMenuError, loading: createDigitalMenuLoading },
	] = useCreateDigitalMenuMutation({
		onCompleted: data => {
			setOpenDialog(false);
			setOpenSnackBar(true);
			setSnackBarMessage(SystemMsgs.createNewRecord());
			// setSnackBarMsg(SystemMsgs.createNewRecord());
		},
	});

	const [
		loadIsDigitalMenuInUse,
		{
			loading: isDigitalMenuInUseLoading,
			data: { isDigitalMenuInUse } = { isDigitalMenuInUse: [] },
		},
	] = useIsDigitalMenuInUseLazyQuery({
		fetchPolicy: 'network-only',
	});

	const moreVertList = [
		{
			name: 'Edit/Menu Pricing',
			action: () => {
				history.push({
					pathname: `/menu/outlet-app/outlet-setting/${outletID}/digital-menu/${menu.ID}/edit`,
					state: menu.obj,
				});
				handleClose();
			},
		},

		{
			name: 'Duplicate',
			action: () => {
				duplicateDigitalMenu({
					variables: {
						digitalMenuID: menu.ID,
						outletID: outletID,
					},
					refetchQueries: [
						{
							query: GetDigitalMenuDocument,
							variables: {
								outletID: outletID,
							},
						},
					],
				});

				handleClose();
			},
		},

		{
			name: 'Delete',
			action: () => {
				setDeleteDialog(true);
				handleClose();
			},
			disabled:
				isDigitalMenuInUse === true || isDigitalMenuInUseLoading === true,
		},
	];

	const onSubmit = (data: any) => {
		newDigitalMenu({
			variables: {
				input: {
					outletID: outletID,
					name: data.name,
					description: data.description,
				},
			},
			refetchQueries: [
				{
					query: GetDigitalMenuDocument,
					variables: {
						outletID: outletID,
					},
				},
			],
		});
	};

	const {
		called: outletCalled,
		loading: outletLoading,
		error: outletError,
		data: { getOutlet } = { getOutlet: [] },
	} = useGetOutletQuery({
		fetchPolicy: 'network-only',
		variables: { ID: outletID },
	});
	const [
			loadCurrency,
			{
				loading: currencyLoading,
				error: currencyError,
				data: { getCurrency } = { getCurrency: [] },
			},
		] = useLazyQuery(GET_CURRENCY, {
			client: AccountClient,
	});
	const outletArray: any[] = getOutlet;
	const [success, setSuccess] = useState({
		msg: '',
		bool: false,
	});

	setTimeout(() => {
		setSuccess({ msg: 'null', bool: false });
	}, 5000);

	return (
		<>
			{digitalMenuLoading && <Loading />}
			{outletLoading && <Loading />}
			{duplicateDigitalMenuLoading && <Loading />}
			{deleteDigitalMenuLoading && <Loading />}
			{createDigitalMenuLoading && <Loading />}

			<MainHeader
				onClick={() =>
					history.push(`/menu/outlet-app/outlet-setting/${outletID}`)
				}
				mainBtn="back"
				smTitle={`Outlet App`}
				title={outletArray[0]?.name}
				routeSegments={[
					{ name: 'Outlet Settings' },
					{ name: 'Digital Menu & Pricing', current: true },
				]}
			/>
			

			<ContentWrapper>
				<div className="message-alert text-noflow">
				<div className="flex-space">
					{/* <IconText
						icon={
						<img
							src={ExcelIcon}
							style={{ width: '19px', paddingRight: '5px' }}
						/>
						}
						font="mdDesc"
						children={
						<>
							<span style={{ fontWeight: 'bold' }}>Download </span>{' '}
							<span>Excel Template</span>
						</>
						}
					></IconText> */}
				<div className="icon-text">
					<img
						src={ExcelIcon}
						style={{ width: '19px', paddingRight: '5px' }}
					/>
					<span className='mdDesc'>
						<span style={{fontWeight:'bold'}}>Download</span>{' '}
						<span>Excel Template</span>
					</span>
				</div>
				</div>
				<div>
					<Button
					type="submit"
					variant="contained"
					color="primary"
					style={{
						minWidth: '0px',
						width: '32px',
						height: '24px',
						margin: '-2px 0px -2px 0px',
					}}
					onClick={() => {
						setOpenExcelDialog(true)
					}}
					>
					<ShareIcon
						style={{
						width: '17px',
						height: '17px',
						}}
					/>
					</Button>
				</div>
				</div>
				<List className="core-list">
					{!digitalMenuLoading &&
					!outletLoading &&
					!isDigitalMenuInUseLoading &&
					(getDigitalMenu === undefined || getDigitalMenu?.length === 0) ? (
						<EmptyList
							title="No Record Found"
							subtitle="Add a new record now"
						/>
					) : (		
						getDigitalMenu?.map((el, index) => (
							// <DigitalMenuLibraryListing
							// 	el={el}
							// 	index={index}
							// 	handleClick={handleClick}
							// 	TLInfo={el?.name}
							// 	BLInfo={el?.description}
							// 	isEmpty={
							// 		getDigitalMenu?.length === 0 || getDigitalMenu === undefined
							// 	}
							// 	moreVertNeeded={true}
							// 	anchorEl={anchorEl}
							// 	handleClose={handleClose}
							// 	moreVertList={morevertList}
							// />
							<>

							<ListItem>
								<ListItemText
									primary={
										<>
											{el?.name && (
												<span className="xsTitle flex-space">{el?.name}</span>
											)}
										</>
									}
									secondary={
										<>
											<span className="desc">
												{el?.description && (
													<span className="xxTitle fw-medium">
														{el?.description}
													</span>
												)}
											</span>
										</>
									}
								/>
								<ListItemSecondaryAction>
									<IconButton
										edge="end"
										aria-label="more"
										aria-controls="menu-list"
										aria-haspopup="true"
										onClick={e => {
											handleClick(e, el.ID, index, el);
											loadIsDigitalMenuInUse({
												variables: {
													outletID: outletID,
													digitalMenuID: el?.ID,
												},
											});
										}}
									>
										<MoreVert />
									</IconButton>
								</ListItemSecondaryAction>
							</ListItem>
							</>

						))
					)
					
					}
				</List>
				<Menu
					disableScrollLock
					id="menu-list"
					anchorEl={anchorEl}
					keepMounted
					open={Boolean(anchorEl)}
					onClose={handleClose}
				>
					{moreVertList?.map((v: any, i: any) => (
						<MenuItem onClick={v?.action} disabled={v?.disabled}>
							<span className="">{v?.name}</span>
						</MenuItem>
					))}
				</Menu>
			</ContentWrapper>

			<ExcelInput 
				showFooter={false}
				showDupErrors={true}
				duplicateItems={duplicateItems}
				errorDia={duplicateErrorDia}
				setErrorDia={setErrorDialog}
				openUpload={openExcelDialog}
				setOpenUpload={setOpenExcelDialog}
				upload={fileTitle}
				template={currentData}
				setTemplate={setCurrentData}
				setUpload={setFileTitle}
				resetFileUpload={resetFileUpload}
				onUploadTemplate={() => {
					const normalize = name => name?.toLowerCase().replace(/\s+/g, "").trim();
					const exceldata=[{
						digitalmenu:[],
						digitalmenucategory:[],
						digitalmenuitemform:[],
						digitalmenuitempriceform:[],
					}]

					const sheetvalidation = (sheetName,targetkey,mapping)=>{
						const sheet = currentData.find(
							s=>normalize(s.sheetName)=== normalize(sheetName)
						);

						if (!sheet) {
							console.warn(`Sheet ${sheetName} not found`);
							return ;
						}

						exceldata[0][targetkey].push({
							sheetName:sheetName,
							rows:sheet.rows.map(mapping),
						})
					}
					const DigitalItemsheet = currentData.find(s=> s.sheetName.trim().toLowerCase()=== "digitalmenu");
					if (!DigitalItemsheet) {
						console.error(`DigitalItemsheet not found in currentData:`,currentData);
						return;
					}

					sheetvalidation("DigitalMenu","digitalmenu",x=>({
						sheetName:"DigitalMenu",

						outletName:x?.outletName === null ? null:`${x?.outletName?.trim()}`,
						name:x?.name === null ?null:`${x?.name?.trim()}`,
						description:x?.description === null ?null:`${x?.description?.trim()}`,
					}))

					sheetvalidation("DigitalMenuCategory","digitalmenucategory",x=>({
						sheetName:"DigitalMenuCategory",

						digitalMenuName:x?.digitalMenuName === null? null:`${x?.digitalMenuName?.trim()}`,
						outletName:x?.outletName === null ? null:`${x?.outletName?.trim()}`,
						name:x?.name === null ?null:`${x?.name?.trim()}`,
						priority:x?.priority === null?null:Number(x?.priority),
					}))

					sheetvalidation("DigitalMenuItemForm","digitalmenuitemform",x=>({
						sheetName:"DigitalMenuItemForm",

						outletName:x?.outletName === null ? null:`${x?.outletName?.trim()}`,
						digitalMenuCategoryName:x?.digitalMenuCategoryName === null? null:`${x?.digitalMenuCategoryName?.trim()}`,
						menuItemName:x?.menuItemName === null? null:`${x?.menuItemName?.trim()}`,
					}))

					sheetvalidation("DigitalMenuItemPriceForm","digitalmenuitempriceform",x=>({
						sheetName:"DigitalMenuItemPriceForm",

						outletName:x?.outletName === null ? null:`${x?.outletName?.trim()}`,
						digitalMenuItemName:x?.digitalMenuItemName === null? null:`${x?.digitalMenuItemName?.trim()}`,
						patronType:x?.patronType === null? null:`${x?.patronType?.trim()}`,
						price:x?.price === null?null:Number(x?.price),
					}))

				// console.log("CURRENT DATA BEFORE SENDING:", currentData);
				history.push({
					pathname: `/menu/outlet-app/outlet-setting/${outletID}/digital-menu/excel-validation`,
					state: {
					excelData:exceldata,
					fileTitle: fileTitle,
					},
				})
				setOpenFileUpload(false)
				}}
				onSelectFile={(e: any) => {
				onSelectFile({ event: e})
				}}
				downloadButton={true}
				onDownloadTemplate={() => {
				onDownloadTemplate({
					name: `Digital_Menu_Template`,
					// workSheetName: null,
					sheet:[
					{
						sheetName:"DigitalMenu",
						headerSetup:digitalMenuForm,
					},
					{
						sheetName:"DigitalMenuCategory",
						headerSetup:digitalMenucategoryForm,
					},
					{
						sheetName:"DigitalMenuItemForm",
						headerSetup:digitalMenuItemForm,
					},
					{
						sheetName:"DigitalMenuItemPriceForm",
						headerSetup:digitalMenuItemPriceForm,
					},
					],
					// headerSetup: extJournalTemplateForm,
					isHeaderLocked: true,
					defaultHeaderFillStyle: {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: 'D3D3D3' },
					},
					defaultHeaderBorderStyle: {
					top: { style: 'thin' },
					left: { style: 'thin' },
					bottom: { style: 'thin' },
					right: { style: 'thin' },
					},
					listType: {
					hasCountry: true,
					hasNationality: true,
					},
					extraListData: [
					{
						data: getCurrency?.map(x => x?.code),
						worksheetName: 'BaseCurrency',
						dataType: 'BaseCurrency',
					},
					{
						data: [
						'No Tax',
						'GST Registration No.',
						'SST Registration No.',
						],
						worksheetName: 'companytax',
						dataType: 'companytax',
					},
					],
				})
				}}
				snackBarProps={{
				openSnackBar: openSnackBar,
				snackBarMessage: snackBarMessage,
				setOpenSnackBar: setOpenSnackBar,
				onClickButton: () => {
					setOpenSnackBar(false)
				},
				}}
				
			/>
			<FloatButton
				onClick={() => {
					setOpenDialog(true);
					setDouble(false);
				}}
			/>

			{/* <form> */}
			<CommonDialog
				fullWidth={true}
				open={openDialog}
				onClose={() => setOpenDialog(false)}
				sections={{
					header: {
						// title: `New Digital Menu `,
						dynamic: (
							<div className="">
								<div className="dialog-dynamic-content">
									<div className="session">
										<div className="flex session">
											<div className="title flex-space">New Digital Menu</div>
										</div>
									</div>
								</div>
							</div>
						),
					},
					body: () => (
						<>
							<CardContents>
								<Controller
									as={TextField}
									name="name"
									label="Digital Menu"
									autoComplete="off"
									multiline={true}
									fullWidth
									margin="normal"
									helperText={errors?.name?.message}
									error={errors?.name ? true : false}
									ref={register}
									control={control}
									required
								/>
								<Controller
									as={TextField}
									name="description"
									label="Description"
									autoComplete="off"
									multiline={true}
									fullWidth
									helperText={errors?.description?.message}
									error={errors?.description ? true : false}
									ref={register}
									control={control}
									required
								/>
							</CardContents>
						</>
					),
					footer: {
						actions: [
							{
								displayText: 'Cancel',
								props: {
									onClick: () => setOpenDialog(false),
									variant: 'contained',
									color: 'primary',
								},
							},
							{
								displayText: 'Save',
								props: {
									variant: 'contained',
									color: 'primary',
									//disabled: isExceed,
									disabled: double,

									onClick: () => {
										handleSubmit(onSubmit)();
										setDouble(true);
									},
								},
							},
						],
					},
				}}
			/>
			{/* </form> */}

			<GeneralDeleteDialog
				ID={menu?.ID}
				refetchID={{ outletID: outletID }}
				openDialog={deleteDialog}
				setOpenDialog={setDeleteDialog}
				dialogName={menu?.obj?.name}
				deleteMutation={deleteDigitalMenu}
				refetchDocument={GetDigitalMenuDocument}
			/>

		</>
	);
};



export const digitalMenuForm=
[
	{
		header: {
			header: 'outletName',
			width: 15,
		},
	},
	{
		header: {
			header: 'name',
			width: 15,
		},
	},
	{
		header:{
			header:'description',
			width:15
		}
	},
]

export const digitalMenucategoryForm = [
	{
		header: {
			header: 'digitalMenuName',
			width: 15,
		},
	},
	{
		header: {
			header: 'outletName',
			width: 15,
		},
	},
	{
		header:{
			header:'name',
			width:15
		}
	},
	{
		header:{
			header:'priority',
			width:15
		}
	},
]

export const digitalMenuItemForm = [
	{
		header: {
			header: 'outletName',
			width: 15,
		},
	},
	{
		header: {
			header: 'digitalMenuCategoryName',
			width: 15,
		},
	},
	{
		header:{
			header:'menuItemName',
			width:15
		}
	},
]

export const digitalMenuItemPriceForm = [
	{
		header: {
			header: 'outletName',
			width: 15,
		},
	},
	{
		header: {
			header: 'digitalMenuItemName',
			width: 15,
		},
	},
	{
		header: {
			header: 'patronType',
			width: 15,
		},
	},
	{
		header:{
			header:'price',
			width:15
		}
	},
]